import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'legendas-component',
    templateUrl: 'legendas-component.html',
    styleUrls: ['./legendas-component.scss']
})

export class LegendasComponent implements OnInit {

    @Input() tipo: string;
    @Input() classCSS: string;
    @Input() qtdBox: number;
    @Input() lista: any = [];

    constructor() {
    }

    ngOnInit() {
    }
}
